// advent.js — bundle picker, gallery, countdown, doors and add-to-cart for the advent landing page
const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

let CartLinesUpdateEvent = null;
try {
  ({ CartLinesUpdateEvent } = await import('@shopify/events'));
} catch (e) {
  CartLinesUpdateEvent = null;
}

function toast(msg) {
  let el = document.querySelector('.adv-toast');
  if (!el) {
    el = document.createElement('div');
    el.className = 'adv-toast';
    el.setAttribute('role', 'status');
    document.body.appendChild(el);
  }
  el.textContent = msg;
  el.classList.add('is-visible');
  clearTimeout(el._t);
  el._t = setTimeout(() => el.classList.remove('is-visible'), 2600);
}

async function addToCart(variantId, quantity, sourceEl, extras = []) {
  const sectionIds = [...document.querySelectorAll('cart-items-component')]
    .map((el) => el.dataset.sectionId)
    .filter(Boolean);
  const hasDrawer = Boolean(document.querySelector('cart-drawer-component'));
  const deferred = CartLinesUpdateEvent ? CartLinesUpdateEvent.createPromise() : null;

  if (CartLinesUpdateEvent && hasDrawer) {
    sourceEl.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: String(variantId), quantity }, ...extras.map((id) => ({ merchandiseId: String(id), quantity: 1 }))],
        promise: deferred.promise,
      })
    );
  }

  const res = await fetch(root + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items: [{ id: Number(variantId), quantity }, ...extras.map((id) => ({ id: Number(id), quantity: 1 }))], sections: sectionIds.join(',') }),
  });
  const data = await res.json();
  const cart = await fetch(root + 'cart.js').then((r) => r.json());

  const failed = !res.ok || data.status;
  if (deferred) {
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        items: cart.items,
        source: 'advent-landing',
        sourceId: 'advent-landing',
        itemCount: quantity,
        sections: failed ? undefined : data.sections,
        didError: Boolean(failed),
      },
    });
  }
  if (failed) throw new Error(data.description || data.message || 'Could not add to cart');

  document.querySelectorAll('[data-cart-count], .cart-count-bubble span').forEach((el) => {
    el.textContent = cart.item_count;
  });

  if (!CartLinesUpdateEvent || !hasDrawer) {
    window.location.href = root + 'cart';
    return;
  }
  toast('Added to your cart ♥');
}

/* ---------- shared state: chosen bundle quantity ---------- */
const state = { qty: 1 };
const fmt = (cents) => {
  const s = document.querySelector('[data-adv-money-format]');
  const format = (s && s.dataset.advMoneyFormat) || '€{{amount_with_comma_separator}}';
  const amount = (cents / 100).toFixed(2);
  const [whole, dec] = amount.split('.');
  return format
    .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + dec)
    .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, whole)
    .replace(/\{\{\s*amount_no_decimals\s*\}\}/, whole)
    .replace(/\{\{\s*amount\s*\}\}/, whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + dec);
};

function syncQty(qty) {
  state.qty = Math.max(1, Math.min(20, qty));
  document.querySelectorAll('[data-adv-qty-input]').forEach((i) => (i.value = state.qty));
  document.querySelectorAll('.adv-tier').forEach((tier) => {
    const match = Number(tier.dataset.qty) === state.qty;
    tier.classList.toggle('is-selected', match);
    const input = tier.querySelector('input');
    if (input) input.checked = match;
  });
  const hero = document.querySelector('[data-adv-hero]');
  if (!hero) return;
  const unit = Number(hero.dataset.unitPrice);
  const tiers = [...document.querySelectorAll('.adv-tier')].map((t) => ({ q: Number(t.dataset.qty), off: Number(t.dataset.discount) }));
  const applicable = tiers.filter((t) => t.q <= state.qty).sort((a, b) => b.q - a.q)[0];
  const off = applicable ? applicable.off : 0;
  const full = unit * state.qty;
  const total = Math.round(full * (100 - off) / 100);
  document.querySelectorAll('[data-adv-total]').forEach((el) => (el.textContent = fmt(total)));
  document.querySelectorAll('[data-adv-full]').forEach((el) => {
    el.textContent = off > 0 ? fmt(full) : '';
    el.hidden = off === 0;
  });
  document.querySelectorAll('[data-adv-save]').forEach((el) => (el.textContent = off > 0 ? `Save ${fmt(full - total)}` : ''));
  const extras = [...document.querySelectorAll('[data-adv-addon]:checked')].reduce((sum, i) => sum + Number(i.dataset.price || 0), 0);
  document.querySelectorAll('[data-adv-grand]').forEach((el) => (el.textContent = fmt(total + extras)));
}

document.addEventListener('click', (e) => {
  const minus = e.target.closest('[data-adv-qty-minus]');
  const plus = e.target.closest('[data-adv-qty-plus]');
  if (minus) syncQty(state.qty - 1);
  if (plus) syncQty(state.qty + 1);

  const tier = e.target.closest('.adv-tier');
  if (tier) syncQty(Number(tier.dataset.qty));

  const pick = e.target.closest('[data-adv-pick]');
  if (pick) {
    e.preventDefault();
    syncQty(Number(pick.dataset.advPick));
    const target = document.querySelector('[data-adv-hero]');
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  const door = e.target.closest('.adv-door');
  if (door) door.classList.toggle('is-open');
});

document.addEventListener('change', (e) => {
  if (e.target.matches('[data-adv-qty-input]')) syncQty(parseInt(e.target.value, 10) || 1);
  if (e.target.matches('[data-adv-addon]')) syncQty(state.qty);
});

document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-adv-add]');
  if (!btn) return;
  e.preventDefault();
  const variantId = btn.dataset.variantId;
  const qty = btn.dataset.qty ? Number(btn.dataset.qty) : state.qty;
  const label = btn.innerHTML;
  const errorEl = document.querySelector('[data-adv-error]');
  btn.classList.add('is-loading');
  btn.textContent = 'Adding…';
  try {
    if (errorEl) errorEl.textContent = '';
    const extras = [...document.querySelectorAll('[data-adv-addon]:checked')].map((i) => i.value);
    await addToCart(variantId, qty, btn, extras);
  } catch (err) {
    if (errorEl) errorEl.textContent = err.message;
    else toast(err.message);
  } finally {
    btn.classList.remove('is-loading');
    btn.innerHTML = label;
    syncQty(state.qty);
  }
});

/* ---------- gallery ---------- */
document.querySelectorAll('[data-adv-gallery]').forEach((gallery) => {
  const main = gallery.querySelector('[data-adv-main]');
  const thumbs = [...gallery.querySelectorAll('.adv-gallery-thumb')];
  if (!main || thumbs.length === 0) return;
  let index = 0;
  const show = (i) => {
    index = (i + thumbs.length) % thumbs.length;
    const t = thumbs[index];
    main.src = t.dataset.full;
    main.srcset = t.dataset.srcset || '';
    main.alt = t.dataset.alt || '';
    thumbs.forEach((th, n) => th.classList.toggle('is-active', n === index));
  };
  thumbs.forEach((t, n) => t.addEventListener('click', () => show(n)));
  gallery.querySelector('.adv-gallery-arrow--prev')?.addEventListener('click', () => show(index - 1));
  gallery.querySelector('.adv-gallery-arrow--next')?.addEventListener('click', () => show(index + 1));
  let x0 = null;
  main.parentElement.addEventListener('touchstart', (e) => (x0 = e.touches[0].clientX), { passive: true });
  main.parentElement.addEventListener('touchend', (e) => {
    if (x0 === null) return;
    const dx = e.changedTouches[0].clientX - x0;
    if (Math.abs(dx) > 40) show(index + (dx < 0 ? 1 : -1));
    x0 = null;
  });
});

/* ---------- countdown ---------- */
document.querySelectorAll('[data-adv-countdown]').forEach((el) => {
  const deadline = new Date(el.dataset.advCountdown + 'T23:59:59');
  if (isNaN(deadline)) return;
  const wrap = el.closest('[data-adv-countdown-wrap]');
  const tick = () => {
    const ms = deadline - new Date();
    if (ms <= 0) {
      if (wrap) wrap.hidden = true;
      return;
    }
    const d = Math.floor(ms / 864e5);
    const h = Math.floor((ms % 864e5) / 36e5);
    const m = Math.floor((ms % 36e5) / 6e4);
    const s = Math.floor((ms % 6e4) / 1e3);
    el.textContent = d > 0 ? `${d}d ${h}h ${m}m` : `${h}h ${m}m ${s}s`;
  };
  tick();
  setInterval(tick, 1000);
});

/* ---------- sticky bar ---------- */
const sticky = document.querySelector('[data-adv-sticky]');
const heroCta = document.querySelector('[data-adv-hero-cta]');
if (sticky && heroCta && 'IntersectionObserver' in window) {
  new IntersectionObserver(([entry]) => {
    sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
  }).observe(heroCta);
}

syncQty(state.qty);
